import React from 'react';
import classnames from 'classnames';
import Button from './Button';
const RoundedLinkButton = ({ additionClasses = '', ...props }) => (<Button additionClasses={classnames(additionClasses, 'btn-rounded')} buttonStyle="link" {...props}/>);
export default RoundedLinkButton;
